function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M200 7.1H83.4L0 82.6v118.3l83.4 75.5H200l83.4-75.5V82.6L200 7.1zm55.1 181.2l-66 59.8H94.4l-66-59.8V95.2l66-59.8h94.8l66 59.8-.1 93.1zM181.3 82.1l-39.6 39.6-39.6-39.6-20 20 39.6 39.6-39.6 39.6 20 20.1 39.6-39.6 39.6 39.6 20.1-20.1-39.6-39.6 39.6-39.6-20.1-20z"
})));